import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import { technologies } from "./tecnologies";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import "./style.css";
import { LeftContent, RightContent } from "../../global-components/src/components/screen/left-content";

const History = () => {
    const siteUrl = "https://pacoca.net";
    const pageUrl = `${siteUrl}/blog/historia`;

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: "A história do Paçoca",
        description:
            "Como a rede social 100% brasileira Paçoca foi criada por João Enrique em 2023 e evoluiu de forma independente.",
        url: pageUrl,
        author: {
            "@type": "Person",
            name: "João Enrique Barbosa Santos Alves",
            url: "https://www.linkedin.com/in/joãoenrique",
        },
        publisher: {
            "@type": "Organization",
            name: "Paçoca Inc.",
            url: siteUrl,
        },
        datePublished: "2023-01-01",
        dateModified: "2025-04-01",
        image: `${siteUrl}/img/pacoca-sem-braco-rounded.png`,
        inLanguage: "pt-BR",
    };

    return (
        <>
          <LeftContent/>
          <RightContent/>
            <Helmet>
                <title>A história do Paçoca – Blog</title>
                <meta
                    name="description"
                    content="Como a rede social 100% brasileira Paçoca foi criada por João Enrique aos 17 anos, em 2023, e cresceu de forma independente — sem investidores."
                />
                <meta
                    name="keywords"
                    content="história do paçoca, como o paçoca foi criado, rede social brasileira, joão enrique, paçoca origem"
                />
                <meta name="author" content="João Enrique Barbosa Santos Alves" />
                <link rel="canonical" href={pageUrl} />

                <meta property="og:type" content="article" />
                <meta property="og:url" content={pageUrl} />
                <meta property="og:title" content="A história do Paçoca – Rede Social Brasileira" />
                <meta
                    property="og:description"
                    content="Como a rede social 100% brasileira Paçoca foi criada por João Enrique aos 17 anos, em 2023, e cresceu de forma independente."
                />
                <meta property="og:image" content={`${siteUrl}/img/pacoca-sem-braco-rounded.png`} />
                <meta property="og:locale" content="pt_BR" />
                <meta property="og:site_name" content="Paçoca" />
                <meta property="article:author" content="João Enrique Barbosa Santos Alves" />
                <meta property="article:published_time" content="2023-01-01" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="A história do Paçoca – Rede Social Brasileira" />
                <meta
                    name="twitter:description"
                    content="Como a rede social 100% brasileira Paçoca foi criada por João Enrique aos 17 anos, em 2023."
                />
                <meta name="twitter:image" content={`${siteUrl}/img/pacoca-sem-braco-rounded.png`} />

                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>

            <div className="blog-post-page">
                <article itemScope itemType="https://schema.org/BlogPosting">
                    <meta itemProp="datePublished" content="2023-01-01" />
                    <meta itemProp="dateModified" content="2025-04-01" />

                    <div className="blog-post-eyebrow">
                        <Link to="/blog">Blog</Link>
                        <span aria-hidden="true">›</span>
                        <span>Origem</span>
                    </div>

                    <h1 className="blog-post-title" itemProp="headline">
                        A história do Paçoca
                    </h1>

                    <p className="blog-post-lead">
                        Uma rede social 100% brasileira, criada do zero por uma pessoa só,
                        sem investidores — e que cresceu de verdade.
                    </p>

                    <hr className="blog-post-divider" />

                    <section>
                        <h5>Quem criou</h5>
                        <p itemProp="description">
                            O Paçoca foi criado por{" "}
                            <strong itemProp="author">João Enrique Barbosa Santos Alves</strong> em
                            2023. Aos 17 anos, João estudava Desenvolvimento de Sistemas na ETEC da
                            Zona Leste e queria construir algo além das atividades escolares.
                        </p>
                        <p>
                            Todo o código, design e estrutura foram feitos e mantidos por João. Hoje
                            ele trabalha na IBM e cursa Análise e Desenvolvimento de Sistemas na Fatec
                            Zona Leste. O projeto nunca teve investidores — é completamente
                            independente.
                        </p>
                    </section>

                    <section>
                        <h5>Como cresceu</h5>
                        <p>
                            A primeira versão do Paçoca foi publicada em um servidor gratuito. O
                            crescimento real aconteceu durante uma instabilidade no Twitter/X: João
                            divulgou a rede no Facebook, o tráfego explodiu e os servidores caíram.
                            Era o sinal de que havia demanda.
                        </p>
                        <p>
                            Em 2024, <strong>Zack</strong> e <strong>Bochecha</strong> entraram no
                            time. Em 2025, <strong>Pixel</strong> assumiu papel central na segurança
                            e liderou a migração para servidores mais robustos.
                        </p>
                    </section>

                    <section>
                        <h5>Expansão técnica</h5>
                        <p>
                            Em 2024, o app oficial para Android e Windows foi lançado em{" "}
                            <strong>React Native</strong>. A versão para iOS está em andamento.
                            Em 1º de abril de 2025, o frontend migrou para <strong>React</strong>,
                            trazendo componentes reutilizáveis, melhor performance e experiência mais
                            fluida para todos os usuários.
                        </p>
                    </section>

                    <hr className="blog-post-divider" />

                    <section>
                        <h5>Stack de tecnologias</h5>
                    <div className="tech-grid">
                        {technologies.map((tech, index) => (
                            <div className="tech-card" key={index}>
                                <div className="tech-icon-wrap">{tech.icon}</div>
                                <h5 className="tech-card-title">{tech.title}</h5>
                                <p className="tech-card-desc">{tech.description}</p>
                            </div>
                        ))}
                    </div>

                        <img
                            style={{ borderRadius: 10, width: "100%", marginTop: "1.5rem" }}
                            src="/img/arquitetura.png"
                            alt="Diagrama de arquitetura do Paçoca"
                        />
                    </section>

                    <hr className="blog-post-divider" />

                    <section>
                        <h5>Fale com o criador</h5>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <a
                                    href="https://www.linkedin.com/in/joãoenrique"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="blog-social-link"
                                    aria-label="LinkedIn de João Enrique"
                                >
                                    <div className="card card-tecnologies shadow-sm border-0">
                                        <div className="card-body d-flex align-items-center">
                                            <FaLinkedin className="text-primary fs-3 me-3" />
                                            <span className="fw-semibold">LinkedIn</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-md-6">
                                <a
                                    href="https://www.github.com/JoaoEnrique"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="blog-social-link"
                                    aria-label="GitHub de João Enrique"
                                >
                                    <div className="card card-tecnologies shadow-sm border-0">
                                        <div className="card-body d-flex align-items-center">
                                            <FaGithub className="fs-3 me-3" />
                                            <span className="fw-semibold">GitHub</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </section>
                </article>
            </div>
        </>
    );
};

export default History;